// index.js
import en from '../lang/en/front-vue.json'
import fr from '../lang/fr/front-vue.json'
import it from '../lang/it/front-vue.json'

export default {
    en: en,
    fr: fr,
    it: it,
}